import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Activity } from "lucide-react";

export default function Monitoring() {
  const [items, setItems] = useState([]);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    (async () => {
      const [m, p] = await Promise.all([api.get("/monitoring"), api.get("/projects")]);
      setItems(m.data);
      setProjects(p.data);
    })();
  }, []);

  const projName = (id) => projects.find((p) => p.id === id)?.project_name || "—";
  const TYPES = ["Air", "Water", "Noise", "STP", "Waste"];

  return (
    <div className="space-y-6 animate-fade-up">
      <div>
        <p className="text-xs uppercase tracking-[0.22em] text-emerald-700 font-semibold mb-2">Sampling & Reports</p>
        <h1 className="text-4xl font-bold tracking-tight text-stone-900" style={{ fontFamily: "Bricolage Grotesque" }}>Environmental Monitoring</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {TYPES.map((t) => {
          const list = items.filter((i) => i.monitoring_type === t);
          return (
            <div key={t} className="bg-white border border-stone-200 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-3">
                <Activity className="w-4 h-4 text-emerald-700" />
                <div className="font-semibold text-stone-900">{t}</div>
                <span className="ml-auto text-[10px] bg-stone-100 px-2 py-0.5 rounded-full font-medium">{list.length}</span>
              </div>
              <div className="space-y-2">
                {list.map((m) => (
                  <div key={m.id} className="border border-stone-100 rounded-lg p-2.5">
                    <div className="text-xs text-stone-500">{projName(m.project_id)}</div>
                    <div className="text-xs text-stone-700 mt-1">{m.scheduled_date}</div>
                    <span className="inline-block mt-1.5 text-[10px] uppercase tracking-wider bg-stone-100 px-2 py-0.5 rounded-full">{m.status}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
